import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import Header from "./../../Header";
import Menu from "./../../Menu";
import "./.././../../assets/css/patient-symptom.css";
import { arrayExpression, thisTypeAnnotation } from "@babel/types";
import { CONFIG, URLS, getAge, makeProfileSummary } from './../../../helpers/Common';
import { Modal , Container} from "react-bootstrap";
import {SURGEON} from './../../../services/Surgeon';
import "bootstrap/dist/css/bootstrap.css";
import $ from 'jquery';

class PatientNarrative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answersData: "",
      narrativeSummary: "",
      allComplains:[],
      completeNarrative:[],
      profileSummary: "",
      addNarrativeStep: 2,
      imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
      patientId:this.props.patientId,
      getComplainLocationData:this.props.getComplainLocationData,
      nextStep: 6,
      prevStep: 4,
      show: false,

    };
    this.addAnotherNarrative    = this.addAnotherNarrative.bind(this);
    this.handleUpdateAction     = this.handleUpdateAction.bind(this);
    this.getAge                 = getAge.bind(this);
    this.makeProfileSummary     = makeProfileSummary.bind(this);

  }

  componentWillMount() {
   
    localStorage.setItem("saveQuest",true);
    localStorage.setItem("editQuest",true);

    // const all_complains_data=this.props.getAllComplains;
    this.setState({...this.state,allComplains:this.props.getAllComplains});

    const patientAnswerData = this.props.getQuestionAnswersData.filter(
        val => val
    );
    let profileData = this.props.getProfileData;
    profileData.dob=profileData.date_of_birth;
    let narrativeSummary = "";

    // Get narrative summary of latest question answers data

    if (!patientAnswerData)
    {
      this.history.push(URLS.master);
      // Object.values(patientAnswerData).forEach(function(row, key) {
      //     narrativeSummary += row.narrative_text+". ";
      // });
      // this.setState({
      //     narrativeSummary: narrativeSummary
      // });
    }


    // Save question answers data into strage and Extract Summray or previous Question Answers

    let saveData = new Array();
    //patientAnswerData['complainLocationData']  = this.props.getComplainLocationData;
    //patientAnswerData['complainType']          = this.props.getComplainData.complain_types;
    saveData.push({
      'optionData':patientAnswerData,
      'complain_type':this.props.getComplainData.complain_types,
      'complain_type_name':this.props.getComplainData.complainTypeDetails.name,
      'complainLocationData':this.props.getComplainLocationData,
      'surgeon_id':this.props.surgeon_id
    });
    //console.log(this.props);
    let data = localStorage.getItem("data");

    if(data)
    {
      data = JSON.parse(data);

      // Get previous narrative summary from strage

      saveData[0]['primary_complain']=0;

      // Add Question Data in Storage array
      data.push(saveData[0]);

    }
    else
    {
      // Add Question Data if user create 1st Complain
      saveData[0]['primary_complain']=1;
      data = saveData;
    }


    // Save data into storage

    localStorage.setItem("data", JSON.stringify(data));
    // Sort Summary by category order and save
    let summryData = new Array();

    let ref=this;


    if(data.length>0){

      summryData = new Array();
      Object.values(data[data.length-1].optionData).forEach(function(row2, key) {


        // console.log("MYROW2")
        // console.log(row2)

        if(Array.isArray(row2)){

          if(row2.length>1){

            // array 0
            // >0
            // pprefix+array split ,+postfix
            let narrativeText=row2[0].prefix +" ";
            row2.forEach((rowItem,key)=>{
              rowItem.narrative_text = rowItem.narrative_text.replace('<x>',rowItem.required_input_text);
              if(key === row2.length-1){

                narrativeText=" " + narrativeText + " and " + rowItem.single_line_text;

              }else{

                narrativeText=" " + narrativeText + rowItem.single_line_text;
                if(key !== (row2.length)-2)
                {
                  narrativeText=" " + narrativeText+ ", "
                }

              }

            });

            narrativeText =" " + narrativeText + " "+ row2[0].postfix;
            // summryData=[...summryData,{'narrative':narrativeText,'order':row2[0].sort_order,'id':row2.question_id}];
            summryData.push({'narrative':narrativeText,'order':row2[0].sort_order,'id':row2[0].question_id});

          }else{

            // console.log("MYROWNEW1");
            // console.log(row2[0]);
            summryData.push({'narrative':row2[0].narrative_text,'order':row2[0].sort_order,'id':row2[0].question_id});

          }

        }else {
          row2.narrative_text = row2.narrative_text.replace('<x>',row2.required_input_text);
          summryData.push({'narrative':row2.narrative_text,'order':row2.sort_order,'id':row2.question_id});

        }

     
      });
      summryData.sort((a, b) => a.order - b.order);
      summryData.sort((a, b) => a.id - b.id);
      Object.values(summryData).forEach(function(_row, _key)
      {

        if(_key == 0)
        {
          _row.narrative = '';
        }
        //console.log('row: ',_row)
        narrativeSummary += _row.narrative+" ";
      });
      // Add spacing between complains
      narrativeSummary +="<br><br><br>"
      //summryData.push({'narrative':'</br></br>'});

  }

    const {_profileSummary,image_and_points} = makeProfileSummary(profileData,data);

    this.setState({...this.state,allComplains:[...this.state.allComplains,{narrativeSummary: _profileSummary +"<br><br>"+narrativeSummary , image_and_points } ]});
    
    this.setState({
      narrativeSummary:_profileSummary+"<br><br>"+narrativeSummary
    });
    this.props.setNarrativeSummary(_profileSummary+narrativeSummary);
    this.props.setAllComplains({profileSummary: _profileSummary ,narrativeSummary: narrativeSummary , image_and_points });
    //this.history.push('/master');

  }
  addAnotherNarrative = e => {
    this.props.setQuestionAnswersData(new Array());
    this.props.setCheckedItems(new Map());
    this.props.handleNextPrevSteps(this.state.addNarrativeStep);
    this.props.setSelectedComplains(this.props.getComplainData.complain_types)
    this.props.addAnotherComplain(true);
  };

  handleAction = e => {

    $(".marker").remove();

    this.props.handleNextPrevSteps(this.state.nextStep);

    if(localStorage.getItem("allComplains")){


      let all_complains=JSON.parse(localStorage.getItem("allComplains"));

      let all_complains_new=all_complains.map((item,key)=>{

        if(item.image_and_points !=null && item.image_and_points.length>0){

          if(item.image_and_points[0].complain_type === this.props.getComplainData.complain_types){
           
            return  this.props.getAllComplains[key];
          }else{
            return item;
          }

        }
        // if(item.narrativeSummary.includes(this.props.getComplainData.complainTypeDetails.id)){
        // }else{
        // }

      });

      localStorage.setItem("allComplains",JSON.stringify(all_complains_new));

    }else{

      localStorage.setItem("allComplains",JSON.stringify(this.props.getAllComplains));

    }

  };
  handleUpdateAction = (e)=>
  {
   
    $(".marker").remove();
    // Remove last question answer data from storage
    localStorage.setItem('editQuest',true)
    localStorage.setItem('saveQuest',true)
    let data = localStorage.getItem("data");

    if(data)
    {
      data = JSON.parse(data);
      data.splice((data.length)-1, 1);
      localStorage.setItem("data", JSON.stringify(data));
    }

    //Set NarrativeUpdate state from props
    this.props.setIsNarrativeUpdate(true);
    this.props.handleNextPrevSteps(this.state.prevStep);
   
  }

  handleClose = () => {
    $(".marker").remove();
    // Remove last question answer data from storage
    localStorage.setItem('editQuest',true)
    localStorage.setItem('saveQuest',true)
    let data = localStorage.getItem("data");

    if(data)
    {
      data = JSON.parse(data);
      data.splice((data.length)-1, 1);
      
      localStorage.setItem("data", JSON.stringify(data));
    }

    //Set NarrativeUpdate state from props
    this.props.setIsNarrativeUpdate(true);
    this.props.handleNextPrevSteps(this.state.prevStep);
    // this.setState({ show: false });
  }

  handleShow = () => {
    
    window.location.replace('/')
    //this.setState({ show: true });

  }

  markPosition=()=>{

    if(this.state.getComplainLocationData.selectedLocation === undefined || this.state.getComplainLocationData.selectedLocation.length == 0){

    }else{

      this.state.getComplainLocationData.selectedLocation.map((item)=>{

        if(item.picCoordinates === undefined){

          var picCoordinates = document.getElementById('pic').getBoundingClientRect();

          this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x);

        }else{

          this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x);

        }

      });

    }

  };


  markPositionForLoop=(selectedLocations,makerKey)=>{

    if(selectedLocations === undefined || selectedLocations.length == 0){

    }else{

      selectedLocations.map((item)=>{

        if(item.picCoordinates === undefined){

          var picCoordinates = document.getElementById('pic').getBoundingClientRect();

          this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

        }else{

          this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

        }

      });

    }

  };

  mark=(markerId, picCoordinates, top, left)=>{
    let markerRadius = 13;
    
    // $(".marker").remove();
    $(".male-img").append(
        $('<div class="marker marker'+ markerId + '"></div>').css({
          position: "absolute",
          top: `calc(${top}px - (${markerRadius}px / 2))`,
          left: `calc(${left}px - (${markerRadius}px / 2))`,
          width: markerRadius + 'px',
          height: markerRadius + 'px',
          backgroundColor: "#990000",
          borderRadius: '50%',
          display: 'inline-block',
        })
    );
  }

  mark=(markerId, picCoordinates, top, left,markerKey)=>{
    let markerRadius = 13;
    // $(".marker").remove();
    $(`.male-img${markerKey}`).append(
        $('<div class="marker marker'+ markerId + '"></div>').css({
          position: "absolute",
          top: `calc(${top}px - (${markerRadius}px / 2))`,
          left: `calc(${left}px - (${markerRadius}px / 2))`,
          width: markerRadius + 'px',
          height: markerRadius + 'px',
          backgroundColor: "#990000",
          borderRadius: '50%',
          display: 'inline-block',
        })
    );
  }

  render() {
    //console.log(this.state);

    // this.markPosition();

    const { title, first_name , last_name , dob , email ,gender , phone } = this.props.getProfileData;


    let ref = this;

    return (
        <React.Fragment>
          <Header
              title="Patient Symptoms Narrative"
              titleImage="ic-medical-result.png"
          />
          <Menu />

          <section className="patient-symptom">
            <div className="container">
              <div className="patient-txt">
                <div className="row">
                  <div className="col-md-3">
                    <div className="narrative-img">
                      <img
                          src={require("../../../assets/img/icons/female-doctor.png")}
                          alt=""
                      />
                      <h2 className="img-title">{CONFIG.Original_Narrative}</h2>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="list-wrapper">
                      { this.props.getAllComplains.map((item,key)=>{
                        setTimeout(()=>{
                          this.markPositionForLoop(item.image_and_points[item.image_and_points.length-1].complainLocationData.selectedLocation,key)
                        },1000);

                        return(

                            <div className="male-model-complain bg-white">
                              <div className="txt-content">
                                { key === 0 ? ReactHtmlParser(`${this.props.getAllComplains[this.props.getAllComplains.length-1].profileSummary}`) : null }
                              </div>
                              <h2 style={{ fontSize:18 }} className="img-title">{ item.image_and_points[item.image_and_points.length-1].complain_type_name } </h2>
                              <div className="container img-cont" style={{  background : 'white' }}>
                                <div className={`male-img male-img${key}`}>
                                  <img id="pic" src={ this.state.imgPath+item.image_and_points[item.image_and_points.length-1].complainLocationData.image} alt=""/>
                                </div>
                              </div>
                              <div className="txt-content">
                                {ReactHtmlParser(item.narrativeSummary)}
                              </div>
                            </div>

                        )
                      }) }
                      <div className="sec-btn patient--btn">

                        <Modal show={this.state.show} onHide={this.handleClose}>
                          <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">Patient Narrative</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Container>
                              <div className="sec-btn patient--btn">
                                <Link to="#" className="btn-img" onClick={this.handleUpdateAction}>
                                  <img
                                      src={require("../../../assets/img/icons/ic-incomplete-native.png")}
                                      alt=""
                                  />
                                  <span>Edit Complain</span>
                                </Link>

                                <Link to="#" className="btn-img" onClick={this.addAnotherNarrative}>
                                  <img
                                      src={require("../../../assets/img/icons/ic-complete-native.png")}
                                      alt=""
                                  />
                                  <span>Add Secondary Complain</span>
                                </Link>
                              </div>
                            </Container>
                          </Modal.Body>
                        </Modal>

                        <Link to="#" onClick={this.handleShow} className="btn-img">
                          <img
                              src={require("../../../assets/img/icons/ic-incomplete-native.png")}
                              alt=""
                          />
                          <span>{CONFIG.Cancel_Narrative}</span>
                        </Link>

                        <Link to="#" className="btn-img" onClick={this.handleAction}>
                          <img
                              src={require("../../../assets/img/icons/ic-complete-native.png")}
                              alt=""
                          />
                          <span>{CONFIG.Accept_Narrative}</span>
                        </Link>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-9">

            </div>
          </div>
        </React.Fragment>
    );
  }
}

export default PatientNarrative;
